import type { AppState, Actions } from '../state';

export function renderSuccess(root: HTMLElement, state: AppState, actions: Actions): void {
  const filename = state.lastUploadedFilename ?? '';
  const isNocturne = state.settings.deliveryMode === 'nocturne-tray';
  const message = isNocturne
    ? `Delivered <code>${esc(filename)}</code> to <strong>${esc(state.selectedMachine || '(machine)')}</strong>.`
    : `Downloaded <code>${esc(filename)}</code> to this device.`;
  const heading = isNocturne ? 'Sent!' : 'Saved!';
  root.innerHTML = `
    <div class="screen screen-success">
      <div class="success-card">
        <div class="success-check">✓</div>
        <h2>${heading}</h2>
        <p>${message}</p>
        <button class="btn btn-primary btn-block" data-action="again">Capture another</button>
      </div>
    </div>
  `;
  root.querySelector<HTMLButtonElement>('[data-action="again"]')!.addEventListener('click', () => {
    actions.go('capture');
  });
}

function esc(value: string): string {
  return value.replace(/[&<>"']/g, (c) => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' })[c]!);
}
